import { action } from 'satcheljs';

/**
 * Signal for launching new event by keyboard
 */
export const invokeNewEventByKeyboard = action('invokeNewEventByKeyboard');
